import script from "./TokenBuyOld.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenBuyOld.vue?vue&type=script&setup=true&lang=js"

import "./TokenBuyOld.vue?vue&type=style&index=0&id=9e9ba56c&lang=scss"
import "./TokenBuyOld.vue?vue&type=style&index=1&id=9e9ba56c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e9ba56c"]])

export default __exports__